export const SEND_MOUSE_POSITION = "mouse/SEND_MOUSE_POSITION";
export const RECEIVE_MOUSE_POSITION = "mouse/RECEIVE_MOUSE_POSITION";
